// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Hnb","widget":"e_Inb","title":"e_Jnb","msrp":"e_Knb","separator":"e_Lnb","textBadge":"e_Mnb"};